import React from 'react';
import { Badge } from 'antd';
import {
  ClockCircleOutlined,
  SettingOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { SubscriptionStatus } from '../../types/subscription';

interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus;
  showIcon?: boolean;
}

const statusConfig: Record<
  SubscriptionStatus,
  { color: string; label: string; icon: React.ReactNode }
> = {
  pending: {
    color: 'default',
    label: 'Pending',
    icon: <ClockCircleOutlined />,
  },
  provisioned: {
    color: 'processing',
    label: 'Provisioning',
    icon: <SettingOutlined />,
  },
  active: {
    color: 'success',
    label: 'Active',
    icon: <CheckCircleOutlined />,
  },
  onboarded: {
    color: 'success',
    label: 'Onboarded',
    icon: <CheckCircleOutlined />,
  },
  suspended: {
    color: 'warning',
    label: 'Suspended',
    icon: <WarningOutlined />,
  },
  cancelled: {
    color: 'error',
    label: 'Cancelled',
    icon: <CloseCircleOutlined />,
  },
  expired: {
    color: 'error',
    label: 'Expired',
    icon: <CloseCircleOutlined />,
  },
};

export const SubscriptionStatusBadge: React.FC<SubscriptionStatusBadgeProps> = ({
  status,
  showIcon = true,
}) => {
  const config = statusConfig[status] || statusConfig.pending;

  return (
    <Badge
      status={config.color as any}
      text={
        <span>
          {showIcon && <span style={{ marginRight: 4 }}>{config.icon}</span>}
          {config.label}
        </span>
      }
    />
  );
};

